
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/abrir-app",
      function () {
        return require("private-next-pages/abrir-app.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/abrir-app"])
      });
    }
  